export const breakpoints = {
  min: 360,
  small: 540,
  medium: 720,
  large: 1080,
  max: 1280,
}
